import {
    React,
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import moment from 'moment';
import numeral from 'numeral';

import { SimsoAction } from 'src/actions/simso.action';
import { BaivietAction } from 'src/actions/baiviet.action';
import { OrderAction } from 'src/actions/order.action';

import CustomSlider from '../CustomSlider';
import CustomSlider1 from '../CustomSlider1';
import { SettingAction } from 'src/actions/setting.action';

const TheHomepageMainLayout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const currentPage = queryParams.get("page");
    const { homepageOrderLimitItems, homepageOrderLimitTotal, homepageOrderLimitFilter } = useSelector(state => state.order);
    const { homepageBaivietLimitItems, homepageBaivietLimitTotal, homepageBaivietLimitFilter } = useSelector(state => state.baiviet);
    const { homepageBaivietKhongNoiBatLimitItems, homepageBaivietKhongNoiBatLimitTotal, homepageBaivietKhongNoiBatLimitFilter } = useSelector(state => state.baiviet);
    const [ten_san_pham, setTenSanPham] = useState("");
    const [loai_sim, setLoaiSim] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [min_custom_price, setMinCustomPrice] = useState("0");
    const [max_custom_price, setMaxCustomPrice] = useState("10,000,000");
    const [min_custom_price_raw, setMinCustomPriceRaw] = useState("0");
    const [max_custom_price_raw, setMaxCustomPriceRaw] = useState("10000000");

    const [banners, setBanners] = useState([]);
    const [banners1, setBanners1] = useState([]);
    const [banners2, setBanners2] = useState([]);
    const [bankAccounts, setBankAccounts] = useState({});
    const [copyright, setCopyright] = useState("");
    const [address, setAddress] = useState("");
    const [hotline, setHotline] = useState("");
    const [facebook, setFacebook] = useState("");
    const [zalo, setZalo] = useState("");

    useEffect(() => {
        async function fetchData() {
            const homepageSettings = await dispatch(SettingAction.getHomepageKeys([
                {
                    "key": "banner",
                },
                {
                    "key": "copyright",
                },
                {
                    "key": "address",
                },
                {
                    "key": "hotline",
                },
                {
                    "key": "facebook",
                },
                {
                    "key": "zalo",
                },
                {
                    "key": "bank_account",
                },
            ]))
          
            if (homepageSettings) {
                try {
                    let banner = JSON.parse(homepageSettings.data.banner);
                    console.log(banner);

                    if (banner) {
                        let tmpBanners = [];

                        if (Object.entries(banner).length > 0) {
                            Object.entries(banner).forEach(([key, value]) => {
                                tmpBanners.push({
                                    image: value.banner_url,
                                    url: value.banner_link,
                                })
                            });

                            setBanners(tmpBanners);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let bank_account = JSON.parse(homepageSettings.data.bank_account);
                    console.log(bank_account);

                    if (bank_account) {
                        setBankAccounts(bank_account);
                    }
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _copyright = homepageSettings.data.copyright;
                    setCopyright(_copyright);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _address = homepageSettings.data.address;
                    setAddress(_address);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _hotline = homepageSettings.data.hotline;
                    setHotline(_hotline);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _zalo = homepageSettings.data.zalo;
                    setZalo(_zalo);
                } catch (error) {
                    console.error(error);
                }

                //==========

                try {
                    let _facebook = homepageSettings.data.facebook;
                    setFacebook(_facebook);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData();
    }, [])

    useEffect(() => {
        async function fetchData1() {
            if (homepageBaivietLimitItems) {
                try {
                    if (homepageBaivietLimitItems) {
                        let tmpBanners1 = [];

                        if (Object.entries(homepageBaivietLimitItems).length > 0) {
                            Object.entries(homepageBaivietLimitItems).forEach(([key, value]) => {
                                tmpBanners1.push({
                                    title: value.title,
                                    createdAt: value.createdAt,
                                    short_description: value.short_description,
                                    image: value.image,
                                    url: `/trang-chu/${value.loai_bai == "bai_viet" ? "posts" : (value.loai_bai == "tin_tuc" ? "news" : "")}/${value.id}`,
                                })
                            });

                            setBanners1(tmpBanners1);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData1();
    }, [homepageBaivietLimitItems])

    useEffect(() => {
        async function fetchData2() {
            if (homepageBaivietKhongNoiBatLimitItems) {
                try {
                    if (homepageBaivietKhongNoiBatLimitItems) {
                        let tmpBanners2 = [];

                        if (Object.entries(homepageBaivietKhongNoiBatLimitItems).length > 0) {
                            Object.entries(homepageBaivietKhongNoiBatLimitItems).forEach(([key, value]) => {
                                tmpBanners2.push({
                                    title: value.title,
                                    createdAt: value.createdAt,
                                    short_description: value.short_description,
                                    image: value.image,
                                    url: `/trang-chu/${value.loai_bai == "bai_viet" ? "posts" : (value.loai_bai == "tin_tuc" ? "news" : "")}/${value.id}`,
                                })
                            });

                            setBanners2(tmpBanners2);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchData2();
    }, [homepageBaivietKhongNoiBatLimitItems])

    useEffect(() => {
        const payload = {
            homepageSimsoPage: 0,
            homepageSimsoLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
            ten_san_pham: "",
            loai_sim: {},
        };
        dispatch(SimsoAction.updateFilter(payload));

        //==========

        const payload1 = {
            homepageOrderLimitPage: 0,
            homepageOrderLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(OrderAction.updateHomepageLimitFilter(payload1));

        //==========

        const payload2 = {
            homepageBaivietLimitPage: 0,
            homepageBaivietLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(BaivietAction.updateHomepageLimitFilter(payload2));

        //==========

        const payload3 = {
            homepageBaivietKhongNoiBatLimitPage: 0,
            homepageBaivietKhongNoiBatLimitLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
        };
        dispatch(BaivietAction.updateHomepageKhongNoiBatLimitFilter(payload3));
    }, []);

    useEffect(() => {
        refreshHomepageContent();
    }, [location.pathname]);

    const refreshHomepageContent = () => {
        // dispatch(OrderAction.homepageLimitList());
        dispatch(BaivietAction.homepageLimitList());
        dispatch(BaivietAction.homepageKhongNoiBatLimitList());
    }
    
    const onLookup = () => {
        // Gán giá trị mặc định
        // queryParams.set("page", 1);

        // Cập nhật URL mà không reload trang
        // navigate({
        //     pathname: location.pathname,
        //     search: `?${queryParams.toString()}`
        // }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
        
        //==========

        if (ten_san_pham) {
            navigate(`/trang-chu/tim-kiem/${ten_san_pham}`);
        } else {
            navigate("/trang-chu");
        }

        // if (ten_san_pham === "") {
        //     alert('Vui lòng nhập số sim cần tìm!');
        //     return;
        // }

        // let outputLoaiSo = [];

        // if (Object.keys(loai_sim).length > 0) {
        //     Object.entries(loai_sim).forEach(([key, value]) => {
        //         if (value == 1) {
        //             outputLoaiSo.push(key);
        //         }
        //     });
        // }

        // const payload = {
        //     homepageSimsoPage: 'no_update',
        //     homepageSimsoLimit: 'no_update',
        //     ten_san_pham: ten_san_pham,
        //     loai_sim: outputLoaiSo,
        //     min_custom_price: min_custom_price_raw,
        //     max_custom_price: max_custom_price_raw,
        // };

        // dispatch(SimsoAction.updateHomepageFilter(payload));

        // if (location.pathname === "/trang-chu") {
        //     dispatch(SimsoAction.homepageList());
        // } else {
        //     navigate("/trang-chu");
        // }
    };

    const chonLoaiSim = (e, value) => {
        setLoaiSim({
            ...loai_sim,
            [value]: e.target.value == 1 ? 2 : 1
        })
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // hoặc 'auto'
        });
    };

    const handleKeyDownSearch = event => {
        if (event.key === 'Enter') {
            onLookup(event);
            setMenuOpen(false);
        }
    };

    const simTypeList = SIM_TYPE_LIST;

    const navItems = [
        { 
            label: "TRANG CHỦ", 
            path: "/trang-chu", 
            new_tab: "no", 
            child: null, 
        },
        { 
            label: "SẢN PHẨM", 
            path: null, 
            new_tab: "no", 
            child: [
                { 
                    label: "XE MÁY ĐIỆN", 
                    path: "/trang-chu/san-pham/xe-may-dien", 
                    new_tab: "no", 
                    child: null, 
                },
                { 
                    label: "XE ĐẠP ĐIỆN", 
                    path: "/trang-chu/san-pham/xe-dap-dien", 
                    new_tab: "no", 
                    child: null, 
                },
                { 
                    label: "ẮC QUY", 
                    path: "/trang-chu/san-pham/ac-quy", 
                    new_tab: "no", 
                    child: null, 
                },
                { 
                    label: "PIN", 
                    path: "/trang-chu/san-pham/pin", 
                    new_tab: "no", 
                    child: null, 
                },
                { 
                    label: "PHỤ TÙNG", 
                    path: "/trang-chu/san-pham/phu-tung", 
                    new_tab: "no", 
                    child: null, 
                },
                { 
                    label: "KHÁC", 
                    path: "/trang-chu/san-pham/khac", 
                    new_tab: "no", 
                    child: null, 
                },
            ], 
        },
        { 
            label: "BÀI VIẾT", 
            path: "/trang-chu/bai-viet", 
            new_tab: "no", 
            child: null,
        },
        { 
            label: "TIN TỨC", 
            path: "/trang-chu/tin-tuc", 
            new_tab: "no", 
            child: null,
        },
    ];

    return (
        <>
            <Helmet>
                <title>Xe điện SH - Xe điện Song Đan</title>
                <link href="https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;600;700&display=swap" rel="stylesheet"></link>
                <link href="https://fonts.googleapis.com/css2?family=Style+Script&display=swap" rel="stylesheet" />
                {/* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;600;700&display=swap" rel="stylesheet" /> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=AR+One+Sans:wght@400;700&display=swap" rel="stylesheet"></link> */}
                {/* <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet"></link> */}

                <style>{`
                    :root {
                        /* --main-color: #005FA8;
                        --background-color: #F8F9FA;
                        --background-color-1: #F0F3F3;
                        --text-color: #3C3C3C; */

                        --main-color: #1464F4;
                        --background-color: #FFFFFF;
                        --background-color-1: #F0F3F3;
                        --text-color: #3C3C3C;

                        /* --main-color: #CDA45E;
                        --background-color: #29261F;
                        --background-color-1: #F0F3F3;
                        --text-color: #FFFFFF; */
                    }

                    html, body, #root, .main-layout {
                        background: var(--background-color) !important;
                        color: var(--text-color);
                    }

                    video {
                        background: #000;
                    }

                    .d-none {
                        display: none !important;
                    }

                    .loading {
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        mix-blend-mode: multiply;
                        margin: auto;
                        background: url(/static/images/loading.gif) no-repeat center center / contain;
                    }

                    .page-btn[disabled], .list-pagination button[disabled] {
                        opacity: 0.5;
                    }

                    .page-btn.current-selected {
                        opacity: 1 !important;
                        background: #FF0000 !important;
                    }

                    .main-layout {
                        /* font-family: muli,Arial,Helvetica,sans-serif; */
                        /* font-family: Times New Roman; */
                        font-family: 'Mulish', sans-serif;
                        display: flex;
                        flex-direction: column;
                        min-height: 100vh;
                    }

                    ul {
                        display: block;
                        list-style-type: disc;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        padding-inline-start: 40px;
                        unicode-bidi: isolate;
                    }

                    ol {
                        display: block;
                        list-style-type: decimal;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        padding-inline-start: 40px;
                        unicode-bidi: isolate;
                    }

                    .main-content {
                        padding: 0 20px 20px 20px;
                        display: flex;
                        gap: 20px;
                        flex-wrap: wrap;
                    }

                    .main-banner {
                        margin-top: 80px;
                    }

                    /* ========== */

                    .nt-header {
                        position: fixed;
                        top: 0;
                        width: 100%;
                        background: var(--background-color);
                        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
                        z-index: 100;
                    }

                    .nt-container {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 20px;
                        height: 80px;
                    }

                    .nt-logo {
                        height: 80px;
                    }
                    
                    .nt-nav ul {
                        list-style: none;
                        display: flex;
                        gap: 20px;
                        margin: 0;
                        padding: 0;
                    }

                    .nt-nav li {
                        position: relative;
                        height: 80px;
                        align-content: center;
                        cursor: pointer;
                    }

                    .nt-nav li * {
                        color: var(--text-color);
                    }

                    .nt-nav li:hover * {
                        color: var(--main-color);
                    }

                    .nt-nav li.dropdown:after {
                        content: "⌄";
                        font-size: 80%;
                        position: absolute;
                        top: 35%;
                        right: -10px;
                        opacity: 0.7;
                    }

                    .nt-nav .dropdown-menu {
                        gap: 0;
                    }

                    .nt-nav .dropdown-menu li {
                        position: relative;
                        height: max-content;
                        align-content: center;
                    }

                    .nt-nav a,
                    .nt-nav span {
                        text-decoration: none;
                        color: var(--text-color);
                        font-weight: 500;
                        cursor: pointer;
                    }

                    .nt-nav .dropdown-menu {
                        position: absolute;
                        top: 60px;
                        right: 0;
                        width: max-content;
                        box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
                        display: none;
                        flex-direction: column;
                        background-color: #FDFDFD;
                        border-style: solid;
                        border-width: 1px;
                        border-color: #7A7A7A;
                        border-radius: 20px;
                    }

                    .nt-nav .dropdown:hover .dropdown-menu {
                        display: flex;
                    }

                    .nt-nav .dropdown-menu li {
                        padding: 10px 20px;
                    }

                    .nt-nav .dropdown-menu li a {
                        color: var(--text-color);
                    }

                    .nt-nav .dropdown-menu li:hover * {
                        color: var(--main-color);
                    }
                    
                    .nt-right {
                        display: flex;
                        align-items: center;
                        /* gap: 10px; */
                    }

                    .nt-btn {
                        padding: 6px 12px;
                        border: 1px solid var(--text-color);
                        background: none;
                        cursor: pointer;
                    }

                    .nt-country-switch {
                        padding: 6px;
                    }

                    .nt-mobile-toggle {
                        display: none;
                        background: none;
                        border: none;
                        font-size: 24px;
                        cursor: pointer;
                    }

                    .nt-footer {
                        background-color: #1d1d1f;
                        color: #fff;
                        font-family: sans-serif;
                        font-size: 14px;
                    }
                    
                    .nt-footer__container {
                        max-width: 1200px;
                        margin: auto;
                        padding: 40px 20px;
                    }
                    
                    .nt-footer__top {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        margin-bottom: 30px;
                    }
                    
                    .nt-footer__column {
                        flex: 1 1 200px;
                        margin-right: 20px;
                    }
                    
                    .nt-footer__column h4 {
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    
                    .nt-footer__column ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    
                    .nt-footer__column li {
                        margin-bottom: 8px;
                    }
                    
                    .nt-footer__column a {
                        color: #ccc;
                        text-decoration: none;
                    }
                    
                    .nt-footer__column a:hover {
                        text-decoration: underline;
                        color: #fff;
                    }
                    
                    .nt-footer__socials {
                        margin-top: 10px;
                    }
                    
                    .nt-footer__socials a {
                        margin-right: 10px;
                        display: inline-block;
                    }
                    
                    .nt-footer__socials img {
                        width: 24px;
                        height: 24px;
                        filter: brightness(0) invert(1);
                    }
                    
                    .nt-footer__bottom {
                        border-top: 1px solid #333;
                        padding-top: 20px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;
                    }
                    
                    .nt-footer__links a {
                        margin-left: 16px;
                        color: #bbb;
                        text-decoration: none;
                    }
                    
                    .nt-footer__links a:hover {
                        color: #fff;
                    }

                    /* Mobile styles */
                    @media (max-width: 768px) {
                        .nt-nav {
                            position: fixed;
                            top: 60px;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: #fff;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            transform: translateY(-100%);
                            transition: transform 0.3s ease;
                        }
                        .nt-nav.open {
                            transform: translateY(0);
                        }
                        .nt-nav ul {
                            flex-direction: column;
                            gap: 20px;
                        }
                        .nt-right .mobile-toggle {
                            display: block;
                        }
                        .nt-right .btn,
                        .nt-right .country-switch {
                            display: none;
                        }
                    } 
                    
                    /* ========== */

                    .mobile-function-container {
                        padding: 80px 10px 10px 10px;
                        position: fixed;
                        width: 100%;
                        height: 100%;
                        overflow-y: auto;
                        /* background: rgb(240, 240, 240); */
                        background: #FFF;
                        z-index: 99999;
                    }

                    .mobile-function-container-opener {
                        display: flex;
                        align-items: center;
                        background: linear-gradient(135deg, var(--main-color), var(--main-color));
                        /* padding: 10px 30px; */
                        /* border-radius: 5px; */
                        box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
                        /* width: 100%; */
                        justify-content: space-between;
                        flex-wrap: wrap;
                        
                        position: fixed;
                        z-index: 100;
                        width: 15px;
                        height: 53px;
                        right: 0;
                        border-radius: 5px 0 0 5px;
                    }

                    .mobile-function-container-opener > button {
                        height: 10px;
                        position: absolute;
                        top: 21px;
                    }

                    .btn-has-icon {
                        font-size: 24px !important;
                        padding: 0 !important;
                    }

                    .contact-icons {
                        position: fixed;
                        bottom: 0;
                        right: 0;
                        opacity: 0.8;
                        z-index: 99999;
                        width: fit-content;
                    }

                    .search-box {
                        margin-top: 20px;
                        margin-bottom: 20px;
                        background: var(--background-color);
                        padding: 10px;
                        border-radius: 5px;
                        box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
                        display: block;
                        align-items: center;
                        z-index: 99999;
                    }

                    .slide-count {
                        font-size: 10px !important;
                    }

                    .contact-icons.left {
                        left: 0;
                    }

                    .contact-icons .icon {
                        width: 50px;
                        height: 50px;
                        display: block;
                        margin: 10px;
                    }

                    .contact-icons .icon > img {
                        width: 100%;
                        height: 100%;
                    }

                    .contact-icons .icon > img[alt='phone'] {
                        padding: 5px;
                        /* border: 2px solid #FFFFFF; */
                        border-radius: 50%;
                        background-color: var(--main-color);
                    }

                    .contact-icons .contact-item-1 {
                        margin: 10px !important;
                        background: var(--main-color) !important;
                    }

                    .contact-item-1 .title, .contact-item-1 .content {
                        display: block;
                    }

                    .contact-item-1 .title {
                        font-style: italic;
                        font-weight: bold;
                        font-size: 12px !important;
                        margin-bottom: 3px;
                    }

                    .contact-item-1 .content {
                        font-weight: bold;
                        font-size: 16px !important;
                    }

                    .contact-item-1 .content-region {
                        display: block;
                    }

                    .contact-panel .contact-item, .contact-item-1 {
                        padding: 5px;
                        width: 163px;
                        height: 41px;
                        margin: auto;
                        background: var(--main-color);
                        border-radius: 50px;
                        display: flex;
                        align-items: center;

                    }

                    .contact-panel .contact-item img, .contact-item-1 img {
                        height: 100%;
                        width: auto;
                    }

                    .contact-panel .contact-item span, .contact-item-1 span {
                        color: #FFFFFF;
                        margin-left: 5px;
                    }

                    .contact-panel .contact-item.zalo, .contact-item-1.zalo {
                        /* background: var(--main-color); */
                    }

                    .contact-panel .contact-item.zalo span, .contact-item-1.zalo span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.facebook, .contact-item-1.facebook {
                        /* background: var(--main-color); */
                    }

                    .contact-panel .contact-item.facebook span, .contact-item-1.facebook span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.messenger, .contact-item-1.messenger {
                        /* background: var(--main-color); */
                    }

                    .contact-panel .contact-item.messenger span, .contact-item-1.messenger span {
                        color: #FFFFFF;
                    }

                    .contact-panel .contact-item.phone, .contact-item-1.phone {
                        /* background: var(--main-color); */
                    }

                    .contact-panel .contact-item.phone span, .contact-item-1.phone span {
                        color: #FFFFFF;
                    }

                    .sim-meaning {
                        margin-bottom: 20px;
                    }

                    .sim-meaning .title {
                        text-align: center;
                        font-size: 20px;
                    }

                    .sim-meaning .meaning {
                        margin: 20px;
                        color: #ad0909;
                        font-size: 45px;
                        /* font-family: 'SVNShintiaScript', Arial, sans-serif; */
                        font-family: 'Style Script', cursive;
                    }

                    .sim-meaning .detail-meaning {
                        line-height: 26px;
                        font-size: 16px;
                    }

                    .sim-analysis {
                        line-height: 26px;
                        font-size: 16px;
                    }

                    .sim-analysis h2 {
                        font-size: 20px;
                        margin: 10px 0;
                    }

                    .baiviet-item .title {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 18px;
                        font-weight: bold;
                        text-align: left;
                    }

                    .baiviet-item .date {
                        font-size: 16px;
                        text-align: left;
                        padding-top: 10px;
                    }

                    .baiviet-item .short-description {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 16px;
                        text-align: left;
                        padding-top: 10px;
                    }

                    .regular-panel > h3 {
                        font-size: 16px;
                    }

                    .filter-item {
                        display: flex;
                        margin-bottom: 5px;
                    }

                    .filter-item .filter-checkbox {
                        width: 20px;
                        height: 15px;
                        margin-right: 5px;
                    }

                    .filter-item .filter-text {
                        width: 100%;
                    }

                    .sim-item {
                        padding: 8px !important;
                        min-height: 81px;
                    }

                    .sim-item .price {
                        margin-top: 5px;
                    }
                    
                    .sim-item .price * {
                        font-size: 18px;
                    }

                    .simvip .operator-icon {
                        min-width: 50px;
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        -moz-box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                        -webkit-box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                        box-shadow: -1px 1px 1px rgba(0,0,0,0.25);
                    }

                    .simvip .sim {
                        font-size: 20px !important;
                        font-weight: bold;
                        text-align: right;
                    }

                    .simvip .sim * {
                        font-size: 20px !important;
                        font-weight: bold;
                    }

                    .simvip .sim .number-highlight {
                        color: #FF0000 !important;
                    }

                    .simvip .price {
                        font-size: 16px !important;
                        font-weight: bold;
                        text-align: right;
                        color: var(--main-color);
                    }

                    .post-show {
                        display: block;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0;
                        background: transparent;
                        border-radius: 10px;
                    }

                    .post-show .post-title {
                        border-bottom: 3px solid gray;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                    }

                    .post-show .post-short-description {
                        margin-bottom: 20px;
                    }

                    .media-content img, 
                    .media-content video,
                    .media-item {
                        max-width: 100% !important;
                        max-height: calc(100vh - 100px) !important;
                        display: block !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                    }

                    .post-show .post-img {
                        margin-bottom: 20px !important;
                    }

                    .simdata5g-item {
                        position: relative;
                        overflow: hidden;
                    }

                    .simdata5g-item img {
                        transition: transform 0.3s ease-in-out;
                    }
                    
                    .simdata5g-item:hover img {
                        transform: scale(1.05);
                    }

                    .simdata5g-item .name {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        /* -webkit-line-clamp: 2; */
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 20px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                    }

                    .simdata5g-item .price {
                        font-size: 24px;
                        font-weight: bold;
                        text-align: left;
                        margin-top: 10px;
                        color: var(--main-color);
                        float: right;
                    }

                    .simdata5g-item .price * {
                        float: right;
                    }

                    .simso-one-detail * {
                        font-size: 18px;
                    }

                    .simso-one-detail .price {
                        font-size: 24px;
                    }

                    .simdata5g-one-detail * {
                        font-size: 18px;
                    }

                    .simdata5g-one-detail .price {
                        font-size: 24px;
                    }

                    .form-dat-hang {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .simso-one-ynghiasim .detail-meaning, .simso-one-ynghiasim .sim-analysis {
                        display: none;
                    }

                    .noti-simple {
                        display: inline;
                        font-size: 80% !important;
                        color: white;
                        background: red;
                        border-radius: 3px;
                        padding: 3px;
                    }

                    .btn-home, .btn-search {
                        font-size: 28px !important;
                    }

                    .pause-stamp {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(-25deg);
                        white-space: nowrap;
                        color: #b30000;
                        border: 3px solid #b30000;
                        padding: 6px 18px;
                        font-weight: 900;
                        font-size: 3vw !important;
                        text-transform: uppercase;
                        /* opacity: 0.9; */
                        opacity: 1.0;
                        border-radius: 4px;
                        font-family: 'Courier New', Courier, monospace;
                        pointer-events: none;
                        z-index: 10;
                        letter-spacing: 2px;
                        background: #f8d7da;
                        box-shadow:
                            0 0 0 1px rgba(179, 0, 0, 0.6),
                            inset 0 0 0 2px rgba(179, 0, 0, 0.3),
                            2px 2px 6px rgba(0, 0, 0, 0.2);
                        filter: contrast(1.2) brightness(1.05);
                        /* mix-blend-mode: multiply; */
                    }

                    .product-one-img{
                        object-fit: contain;
                        max-height: 80vh;
                    }

                    .product-one-banner {
                        width: 50%;
                        /* mix-blend-mode: multiply; */
                        background: rgba(0,0,0,1);
                    }

                    .product-detail-banner {
                        width: 100%;
                        height: 25vw;
                        max-height: 300px;
                        /* mix-blend-mode: multiply; */
                        background: rgba(0,0,0,1);
                    }

                    .product-detail-banner .product-one-img{
                        object-fit: contain;
                        height: 100%;
                        max-height: 100%;
                    }

                    .product-one-detail-container {
                        padding-top: 0 !important;
                    }

                    .product-one-detail .title {
                        display: block;
                        font-size: 34px !important;
                        margin-top: 15px;
                        margin-bottom: 15px;
                    }

                    .product-one-detail .price {
                        display: block;
                        font-size: 32px !important;
                        margin-bottom: 15px;
                    }

                    .product-one-detail .price * {
                        font-size: 32px !important;
                    }

                    .product-one-detail .price .select-price, .product-one-detail .price .select-price * {
                        font-size: 24px !important;
                    }

                    .product-one-detail .price .price-old {
                        margin-left: 15px;
                        font-size: 80% !important;
                    }

                    .product-one-detail .status {
                        display: block;
                        font-size: 28px !important;
                    }

                    .product-short-content, .product-short-content * {
                        background: transparent !important;
                        color: gray !important;
                        font-size: 18px !important;
                    }

                    .product-content img {
                        max-width: 100% !important;
                    }

                    .order-btn {
                        display: block;
                        text-align: center;
                        align-items: center;
                        gap: 8px;
                        background-color: #4CAF50;
                        color: white;
                        padding: 12px 18px;
                        /* margin: 8px; */
                        text-decoration: none;
                        border-radius: 8px;
                        font-weight: bold;
                        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                        transition: background-color 0.2s ease, transform 0.1s ease;
                    }
                      
                    .order-btn:hover {
                        background-color: #45a049;
                        transform: scale(1.03);
                    }

                    .order_container {
                        padding: 15px !important;
                        font-family: Mulish, sans-serif;
                    }

                    .order_container * {
                        font-family: Mulish, sans-serif;
                    }

                    .regular-item {
                        position: relative;
                        overflow: hidden;
                        /* mix-blend-mode: multiply; */
                    }

                    .regular-item img {
                        transition: transform 0.3s ease-in-out;
                    }
                    
                    .regular-item:hover img {
                        transform: scale(1.05);
                    }

                    .regular-item:hover .product-detail-banner img.product-one-img {
                        transform: none;
                    }

                    .regular-item .name {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        /* -webkit-line-clamp: 2; */
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        font-size: 16px;
                        font-weight: 600;
                        text-align: left;
                        margin-top: 10px;

                        cursor: pointer;
                    }

                    .regular-item .name:hover {
                        color: var(--main-color) !important;
                    }

                    .regular-item .image-container {
                        cursor: pointer;
                    }

                    .regular-item .price {
                        font-size: 20px;
                        font-weight: 800;
                        text-align: left;
                        margin-top: 10px;
                        color: var(--main-color);
                        /* float: right; */
                        float: left;
                        width: 40%;
                    }

                    .regular-item .price * {
                        /* float: right; */
                        float: left;
                    }

                    .view-product-dialog .MuiDialog-paper {
                        width: 100% !important;
                        max-width: 100% !important;
                    }

                    .regular-item .view-btn-region {
                        float: right;
                    }

                    .btn-buy-now {
                        margin-top: 10px;
                        /* float: right; */
                    }

                    .btn-buy-now.bestSale-btn {
                        align-items: center;
                        /* background: #1464f4; */
                        background: var(--main-color);
                        border-radius: 50px;
                        color: #fff;
                        display: flex;
                        font-size: 9px !important;
                        font-weight: 700;
                        height: 30px;
                        justify-content: center;
                        line-height: 12px;
                        padding: 5px;
                        text-align: center;
                        text-transform: uppercase;
                        width: 120px;
                    }

                    .btn-buy-now.bestSale-btn p {
                        align-items: center;
                        display: flex;
                        gap: 8px;
                        justify-content: center;
                        font-size: 9px !important;
                    }

                    .btn-view {
                        height: 30px !important;
                        width: 30px !important;
                        border-radius: 50% !important;
                        background-color: #4CAF50 !important;
                        float: left;
                        margin-right: 5px;
                        border: none;
                        cursor: pointer;
                    }

                    .discover-title {
                        font-weight: 600;
                        text-align: center;
                        margin: 25px 0;
                    }

                    .discover-title span {
                        display: block;
                    }

                    .discover-title .style-title01 {
                        font-size: 20px;
                        line-height: 1.2;
                        margin-bottom: 12px;
                    }

                    .discover-title .style-title02 {
                        font-size: 32px;
                    }

                    .footer {
                        background-color: #f4f4f4;
                        color: #333;
                        font-size: 14px;
                    }

                    .footer .container {
                        max-width: 1200px;
                        margin: auto;
                        padding: 40px 20px;
                    }

                    .footer__top {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 20px;
                    }

                    .footer__column {
                        flex: 1 1 200px;
                    }

                    .footer__column h4 {
                        margin-bottom: 12px;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .footer__column ul {
                        list-style: none;
                        padding: 0;
                    }

                    .footer__column li {
                        margin-bottom: 8px;
                    }

                    .footer__column a {
                        text-decoration: none;
                        color: inherit;
                    }

                    .footer__bottom {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-top: 20px;
                        border-top: 1px solid #ddd;
                    }

                    .footer__ecosystem a {
                        margin-left: 16px;
                        color: #555;
                    }

                    @media (max-width: 1199px) {
                        .nt-nav a, .nt-nav span {
                            font-size: 1.5vw !important;
                        }
                    }

                    @media (max-width: 991px) {
                        .regular-item .price {
                            width: 100%;
                        }

                        .regular-item .view-btn-region {
                            float: left;
                        }

                        .btn-buy-now, .btn-view {
                            margin-top: 0;
                        } 
                    }

                    @media (min-width: 768px) {
                        .mobile {
                            display: none;
                        }
    
                        .desktop {
                            display: block;
                        }

                        .main-content {
                            width: 95%;
                            max-width: 1363px;
                            margin-left: auto;
                            margin-right: auto;
                        }

                        .btn-search {
                            /* border-radius: 0 5px 5px 0; */
                            border-radius: 5px 0 0 5px;
                        }

                        .filter-container * {
                            font-size: 16px !important;
                        }
                    }

                    @media (max-width: 768px) {
                        .main-content {
                            padding: 0 10px 10px 10px;
                        }

                        .home-logo {
                            text-align: center;
                            width: 100%;
                        }

                        .header-container {
                            flex-direction: column;
                            align-items: center;
                        }

                        .main-content {
                            flex-direction: column;
                        }

                        .mobile {
                            display: block;
                        }
    
                        .desktop {
                            display: none !important;
                        }

                        .sim-list-show{
                            grid-template-columns: repeat(2, 1fr) !important;
                        }

                        .baiviet-list-show{
                            grid-template-columns: repeat(1, 1fr) !important;
                        }

                        .tintuc-list-show{
                            grid-template-columns: repeat(1, 1fr) !important;
                        }

                        .simdata5g-list-show{
                            grid-template-columns: repeat(2, 1fr) !important;
                        }

                        .page-content {
                            max-width: 100%;
                            /* padding-top: 20px; */
                        }

                        .btn-search {
                            border-radius: 0;
                            /* border-right: 1px solid var(--main-color) !important; */
                        }

                        .search-textbox {
                            border-radius: 0 !important;
                        }

                        .search-box {
                            margin-top: 0;
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100%;
                        }

                        .contact-icons .icon {
                            width: 40px;
                            height: 40px;
                        }

                        .main-banner {
                            margin-top: 60px;
                        }

                        .simvip .operator-icon {
                            min-width: 35px;
                            width: 35px;
                            height: 35px;
                        }

                        .simvip .sim {
                            font-size: 20px !important;
                        }

                        .simvip .sim * {
                            font-size: 20px !important;
                        }

                        .simvip .price {
                            font-size: 16px !important;
                        }

                        .sim-meaning .title, .sim-meaning .title > b {
                            font-size: 16px !important;
                        }
    
                        .sim-meaning .meaning * {
                            font-size: 30px !important;
                            margin: 10px;
                        }
    
                        .sim-meaning .detail-meaning * {
                            line-height: 18px !important;
                        }
    
                        .sim-analysis div * {
                            line-height: 18px !important;
                        }
    
                        .sim-analysis h2 {
                            font-size: 16px !important;
                        }

                        .simdata5g-one-detail-container {
                            display: block !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-img {
                            width: 100% !important;
                            padding: 0 0 20px 0 !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-detail {
                            width: 100% !important;
                            padding: 0 !important;
                        }

                        .simdata5g-one-detail-container .simdata5g-one-detail .price {
                            font-size: 22px !important;
                        }

                        .simso-one-detail-container {
                            display: block !important;
                        }

                        .simso-one-detail-container .simso-one-img {
                            width: 100% !important;
                            padding: 0 0 20px 0 !important;
                        }

                        .simso-one-detail-container .simso-one-detail {
                            width: 100% !important;
                            padding: 0 !important;
                        }

                        .simso-one-detail-container .simso-one-detail .so-sim {
                            font-size: 24px !important;
                        }

                        .simso-one-detail-container .simso-one-detail .price {
                            font-size: 22px !important;
                        }

                        .form-dat-hang {
                            grid-template-columns: repeat(1, 1fr);
                        }

                        .product-one-detail-container {
                            display: block !important;
                        }

                        .product-one-banner {
                            width: 100%;
                        }

                        .product-one-detail {
                            width: 100% !important;
                            padding-left: 0 !important;
                        }

                        .product-one-detail .title {
                            font-size: 30px !important;
                        }
    
                        .product-one-detail .price {
                            font-size: 28px !important;
                        }
    
                        .product-one-detail .price * {
                            font-size: 28px !important;
                        }

                        .product-one-detail .price .select-price, .product-one-detail .price .select-price * {
                            font-size: 20px !important;
                        }
    
                        .product-one-detail .price .price-old {
                            font-size: 80% !important;
                        }
    
                        .product-one-detail .status {
                            font-size: 24px !important;
                        }

                        .regular-list-show{
                            grid-template-columns: repeat(1, 1fr) !important;
                        }

                        .regular-item img {
                            height: 50vw !important;
                        }

                        .product-detail-banner img.product-one-img {
                            height: 100% !important;
                        }

                        .product-detail-banner {
                            height: 60vw !important;
                            max-height: 60vw !important;
                        }

                        .slider-item {
                            height: 50vh !important;
                        }

                        .footer__top {
                            flex-direction: column;
                        }

                        .footer__bottom {
                            flex-direction: column;
                            text-align: center;
                            gap: 12px;
                        }
                    }

                    @media (max-width: 1199px) {
                        * {
                            font-size: 16px !important;
                        }
                    }
                `}</style>
            </Helmet>
            {/* <div className="main-layout" onClick={() => { refreshHomepageContent(); }}> */}
            <div className="main-layout">
                <header className="desktop nt-header">
                    <div className="nt-container">
                        <div className="nt-left">
                            <img style={{cursor: 'pointer'}} onClick={() => { navigate('/trang-chu'); setMenuOpen(false); }} src={`/static/logo.png`} alt="Xe điện SH - Xe điện Song Đan" className="nt-logo"/>
                        </div>

                        <nav className={`nt-nav ${mobileOpen ? 'open' : ''}`}>
                            <ul>
                                {navItems.map((item, index) => (<>
                                    {!item.child && <li>
                                        <Link
                                            to={item.path}
                                            target={item.new_tab == 'yes' ? '_blank' : ''}
                                            rel={item.new_tab == 'yes' ? 'noopener noreferrer' : ''}
                                        >
                                            {item.label}
                                        </Link>
                                    </li>}

                                    {item.child && <li className="dropdown">
                                        <span>{item.label}</span>
                                        <ul className="dropdown-menu">
                                            {item.child.map((item1, index1) => (
                                                <li>
                                                    <Link
                                                        to={item1.path}
                                                        target={item1.new_tab == 'yes' ? '_blank' : ''}
                                                        rel={item1.new_tab == 'yes' ? 'noopener noreferrer' : ''}
                                                    >
                                                        {item1.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>}
                                </>))}
                            </ul>
                        </nav>

                        <div className="nt-right">
                            {/* <button className="nt-btn dealer">Locate Dealer</button>
                            <button className="nt-btn sign-in">Sign In</button>
                            <select className="nt-country-switch">
                                <option>US</option>
                                <option>VN</option>
                            </select>
                            <button className="nt-mobile-toggle" onClick={()=> setMobileOpen(!mobileOpen)}>
                                ☰
                            </button> */}

                            <input 
                                className='search-textbox'
                                type="text" 
                                placeholder="Tìm kiếm..." 
                                name="ten_san_pham"
                                onChange={(e) => { setTenSanPham(e.target.value); }}
                                onKeyDown={handleKeyDownSearch}
                                value={ten_san_pham}
                                style={{
                                    flex: "1", 
                                    padding: "10px", 
                                    fontSize: "16px", 
                                    borderRadius: "5px 0 0 5px",
                                    border: "1px solid var(--main-color)", 
                                    textAlign: "left",
                                    height: "40px",
                                }} />
                            <button 
                                className='btn-search btn-has-icon'
                                onClick={(e) => { onLookup(e); setMenuOpen(false); }}
                                style={{
                                    // width: "100px", 
                                    width: "40px",
                                    height: "40px", 
                                    padding: "10px", 
                                    fontSize: "16px", 
                                    background: "var(--main-color)", 
                                    color: "#fff", 
                                    border: "1px solid var(--main-color)", 
                                    // borderRadius: "0 5px 5px 0", 
                                    cursor: "pointer",
                                    transition: "background 0.3s",
                                    transform: "rotateY(-180deg)",
                                }}
                                onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                            >
                                ⌕
                            </button>
                        </div>
                    </div>
                </header>

                {(location.pathname === "/trang-chu") && <CustomSlider className="main-banner" banners={banners} showSlideCount={1} showPrevBtn={1} showNextBtn={1} />}

                {(location.pathname !== "/trang-chu") && <>
                    <div className='mobile' style={{ width: '100%', height: 60 }}></div>
                    <div className='desktop' style={{ width: '100%', height: 80 }}></div>
                </>}

                {/* Contact Icons */}
                <div className='contact-icons left'>
                    <a className='contact-item-1 phone' href={`tel:${hotline ? hotline.replace(/\./g, '') : ''}`}>
                        <img src="/static/images/phone_white.svg" alt="phone" />
                        <div className='content-region'>
                            <span className='title'>Gọi mua hàng</span>
                            <span className='content'>{hotline}</span>
                        </div>
                    </a>
                </div>
                <div className='contact-icons'>
                    <a className='icon' href={`https://zalo.me/${zalo ? zalo.replace(/\./g, '') : ''}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/zalo.svg" alt="zalo" />
                    </a>
                    <a className='icon' href={`https://facebook.com/${facebook}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/facebook.svg" alt="facebook" />
                    </a>
                    <a className='icon' href={`https://m.me/${facebook}`} target='_blank' rel="noopener noreferrer">
                        <img src="/static/images/messenger.svg" alt="messenger" />
                    </a>
                </div>
                
                {/* Hamburger Menu Button */}
                <div onClick={() => { setMenuOpen(!menuOpen); }} className='mobile d-none' style={{padding: "20px 20px 0 20px"}}>
                    <div className="header-container mobile-function-container-opener" style={{
                        
                    }}>
                        <button onClick={() => { setMenuOpen(!menuOpen); }} style={{ background: "none", border: "none", fontSize: "30px", cursor: "pointer", color: "#FFFFFF" }}>
                            {/* ☰ */}
                            {menuOpen ? ">" : "<"}
                        </button>
                    </div>
                </div>

                {menuOpen && (
                    <div className='mobile mobile-function-container'>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: 15 }}>
                            {navItems.map((item, index) => (<>
                                <button
                                    key={index}
                                    onClick={() => {
                                        setMenuOpen(false);
                                        if (item.new_tab == 'yes') {
                                            window.open(item.path, "_blank");
                                        } else {
                                            navigate(item.path);
                                        }
                                    }}
                                    style={{
                                        // width: "40px",
                                        // height: "40px", 
                                        flex: '1 1 0%',
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        borderRadius: "5px", 
                                        cursor: "pointer",
                                        transition: "background 0.3s",
                                        minWidth: 180,
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    {item.label}
                                </button>
                            </>))}
                        </div>
                    </div>
                )}
                
                {/* Main Content */}
                <main className="main-content">
                    {/* Main Section (8/10) */}
                    <section className='page-content' style={{ flex: "10" }}>
                        <div className='search-box mobile'>
                            <div style={{display: 'flex'}}> 
                                <button 
                                    className='btn-home mobile btn-has-icon'
                                    onClick={() => { navigate('/trang-chu'); setMenuOpen(false); }}
                                    style={{
                                        width: "40px",
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        borderRadius: "5px 0 0 5px", 
                                        cursor: "pointer",
                                        transition: "background 0.3s"
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ⌂
                                </button>
                                <input 
                                    className='search-textbox'
                                    type="text" 
                                    placeholder="Tìm kiếm..." 
                                    name="ten_san_pham"
                                    onChange={(e) => { setTenSanPham(e.target.value); }}
                                    onKeyDown={handleKeyDownSearch}
                                    value={ten_san_pham}
                                    style={{
                                        flex: "1", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        borderRadius: "5px 0 0 5px",
                                        border: "1px solid var(--main-color)", 
                                        textAlign: "left",
                                        height: "40px",
                                    }} />
                                <button 
                                    className='btn-search btn-has-icon'
                                    onClick={(e) => { onLookup(e); setMenuOpen(false); }}
                                    style={{
                                        // width: "100px", 
                                        width: "40px",
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        // borderRadius: "0 5px 5px 0", 
                                        cursor: "pointer",
                                        transition: "background 0.3s",
                                        transform: "rotateY(-180deg)",
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ⌕
                                </button>
                                <button 
                                    className='mobile btn-has-icon'
                                    onClick={() => { setMenuOpen(!menuOpen); }}
                                    style={{
                                        // width: "100px", 
                                        width: "40px", 
                                        height: "40px", 
                                        padding: "10px", 
                                        fontSize: "16px", 
                                        background: "var(--main-color)", 
                                        color: "#fff", 
                                        border: "1px solid var(--main-color)", 
                                        borderRadius: "0 5px 5px 0", 
                                        cursor: "pointer",
                                        transition: "background 0.3s"
                                    }}
                                    onMouseEnter={e => e.target.style.background = "var(--main-color)"}
                                    onMouseLeave={e => e.target.style.background = "var(--main-color)"}
                                >
                                    ☰
                                </button>
                            </div>
                        </div>

                        <div>
                            <Outlet />
                        </div>
                    </section>

                    {/* Blog Section (2/10) */}
                    <section className='d-none' style={{ flex: "2" }}>
                        {/* <aside className='desktop regular-panel' style={{ flex: "2", background: "var(--background-color)", marginBottom: "5px", padding: "5px", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)" }}>
                            <h3 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "12px", color: "#fff", textAlign: "left", marginBottom: "5px", background: "linear-gradient(135deg, var(--main-color), var(--main-color))", padding: "5px", borderRadius: "5px" }}>ĐƠN HÀNG MỚI</h3>
                            <div className='post-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "5px" }}>
                                {homepageOrderLimitItems && homepageOrderLimitItems.map((order, index) => (
                                    order ? <Link to={`#`} className="simvip" onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                                        <div style={{width: "calc(100% - 50px)"}}>
                                            <div className="title" style={{ fontWeight: "bold", fontSize: "12px", textAlign: "left" }}>{order.name}</div>
                                            <div className="short-description" style={{ fontSize: "11px", textAlign: "left", paddingTop: '5px' }}>
                                                {order.ordered_ten_san_pham}
                                            </div>
                                            <div className="date" style={{ fontSize: "10px", textAlign: "left", paddingTop: '5px' }}>
                                                <div style={{
                                                    background: "rgb(50, 118, 53)",
                                                    fontSize: "78%",
                                                    color: "rgb(255, 255, 255)",
                                                    fontWeight: "600",
                                                    borderBottomRightRadius: "10px",
                                                    borderTopRightRadius: "10px",
                                                    lineHeight: "1",
                                                    marginRight: "5px",
                                                    padding: "4px 5px",
                                                    display: "inline",
                                                }}>
                                                    Đã đặt mua
                                                </div>
                                                {moment(order.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                            </div>
                                        </div>
                                    </Link> : null
                                ))}
                            </div>
                        </aside> */}

                        <aside className='desktop regular-panel' style={{ flex: "2", background: "var(--background-color)", marginBottom: "5px", padding: "5px", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)" }}>
                            <h3 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "16px", color: "#fff", textAlign: "left", marginBottom: "5px", background: "linear-gradient(135deg, var(--main-color), var(--main-color))", padding: "5px", borderRadius: "5px" }}>LIÊN HỆ</h3>
                            <div className='contact-panel' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "5px" }}>
                                <a className='contact-item phone' href={`tel:${hotline ? hotline.replace(/\./g, '') : ''}`}>
                                    <img src="/static/images/phone_white.svg" alt="phone" />
                                    <span>{hotline}</span>
                                </a>
                                <a className='contact-item zalo' href={`https://zalo.me/${zalo ? zalo.replace(/\./g, '') : ''}`} target='_blank' rel="noopener noreferrer">
                                    <img src="/static/images/zalo.svg" alt="zalo" />
                                    <span>{zalo}</span>
                                </a>
                                <a className='contact-item facebook' href={`https://facebook.com/${facebook}`} target='_blank' rel="noopener noreferrer">
                                    <img src="/static/images/facebook.svg" alt="facebook" />
                                    <span>{facebook}</span>
                                </a>
                                <a className='contact-item messenger' href={`https://m.me/${facebook}`} target='_blank' rel="noopener noreferrer">
                                    <img src="/static/images/messenger.svg" alt="messenger" />
                                    <span>{facebook}</span>
                                </a>
                            </div>
                        </aside>

                        <aside className='desktop regular-panel' style={{ flex: "2", background: "var(--background-color)", marginBottom: "5px", padding: "5px", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)" }}>
                            <h3 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "16px", color: "#fff", textAlign: "left", marginBottom: "5px", background: "linear-gradient(135deg, var(--main-color), var(--main-color))", padding: "5px", borderRadius: "5px" }}>TK NGÂN HÀNG</h3>
                            <div className='bank-account-panel' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "5px" }}>
                                {bankAccounts && Object.entries(bankAccounts).length > 0 && Object.values(bankAccounts).map((bankAccount, index) => (
                                    bankAccount && bankAccount.bankName && bankAccount.bankAccountNumber && bankAccount.bankAccountOwner ? <div className="bank-account-item" onMouseEnter={e => e.currentTarget.style.border = "1px solid var(--main-color)"} onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"} style={{ display: "block", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}>
                                        <img src={`https://img.vietqr.io/image/${bankAccount.bankName}-${bankAccount.bankAccountNumber.replace(/\./g, '')}-qr_only.jpg`} alt={bankAccount.bankName ? bankAccount.bankName : ''}  style={{ width: "100%", height: "auto" }} />
                                        <div style={{width: "100%"}}>
                                            <div className="" style={{ color: "var(--main-color)", width: "100%", textAlign: 'center', fontSize: "16px" }}>{bankAccount.bankName}</div>
                                            <div className="" style={{ color: "#037319", width: "100%", textAlign: 'center', fontSize: "18px", fontWeight: "bold", paddingTop: '5px' }}>{bankAccount.bankAccountNumber}</div>
                                            <div className="" style={{ color: "#808080", width: "100%", textAlign: 'center', fontSize: "16px", paddingTop: '5px' }}>{bankAccount.bankAccountOwner}</div>
                                        </div>
                                    </div> : null
                                ))}
                            </div>
                        </aside>

                        <aside className='regular-panel' style={{ flex: "2", background: "var(--background-color)", padding: "5px", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)" }}>
                            <h3 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "16px", color: "#fff", textAlign: "left", marginBottom: "5px", background: "linear-gradient(135deg, var(--main-color), var(--main-color))", padding: "5px", borderRadius: "5px" }}>TIN HOT <div className='noti-simple'>{banners1 ? banners1.length : DEFAULT_HOMEPAGE_ROW_PER_PAGE}</div></h3>
                            <div className='baiviet-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "5px" }}>
                                <CustomSlider1 className="news-banner" banners={banners1} showSlideCount={1} showPrevBtn={1} showNextBtn={1} />
                            </div>
                        </aside>

                        <aside className='regular-panel' style={{ flex: "2", background: "var(--background-color)", padding: "5px", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)" }}>
                            <h3 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "16px", color: "#fff", textAlign: "left", marginBottom: "5px", background: "linear-gradient(135deg, var(--main-color), var(--main-color))", padding: "5px", borderRadius: "5px" }}>TIN KHÁC <div className='noti-simple'>{banners2 ? banners2.length + `${homepageBaivietKhongNoiBatLimitTotal && homepageBaivietKhongNoiBatLimitTotal > DEFAULT_HOMEPAGE_ROW_PER_PAGE ? "+" : ""}` : DEFAULT_HOMEPAGE_ROW_PER_PAGE}</div></h3>
                            <div className='baiviet-list-show' style={{ display: "grid", gridTemplateColumns: "repeat(1, 1fr)", gap: "5px" }}>
                                <CustomSlider1 className="news-banner" banners={banners2} showSlideCount={1} showPrevBtn={1} showNextBtn={1} />
                            </div>
                        </aside>
                    </section>
                </main>
                
                {/* Footer */}
                <footer style={{ background: "linear-gradient(135deg, var(--background-color-1), var(--background-color-1))", color: "var(--text-color)", padding: "20px", textAlign: "center", marginTop: "20px" }}>
                    <p style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>{copyright}</p>
                    <p>Địa chỉ: {address} - Điện thoại: {hotline}</p>
                </footer>

                {/* <footer className="footer">
                    <div className="footer__top container">
                        <div className="footer__column">
                            <h4>About VinFast</h4>
                            <ul>
                                <li><a href="/about">Giới thiệu</a></li>
                                <li><a href="/press">Tin tức</a></li>
                                <li><a href="/investor">Nhà đầu tư</a></li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4>Showroom & Đại lý</h4>
                            <ul>
                                <li><a href="/showrooms">Tìm showroom</a></li>
                                <li><a href="/dealers">Danh sách đại lý</a></li>
                                <li><a href="/e-scooters">Xe máy điện</a></li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4>Chính sách & Hỗ trợ</h4>
                            <ul>
                                <li><a href="/terms">Điều khoản</a></li>
                                <li><a href="/privacy">Chính sách bảo mật</a></li>
                                <li><a href="mailto:[email protected]">Email: [email protected]</a></li>
                                <li>Hotline: 1900 23 23 89</li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4>Dịch vụ khách hàng</h4>
                            <ul>
                                <li><a href="/maintenance">Bảo trì & Bảo hành</a></li>
                                <li><a href="/faq">FAQ's</a></li>
                                <li><a href="/contact">Liên hệ</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer__bottom container">
                        <div className="footer__legal">
                            <p>© {new Date().getFullYear()} VinFast. All rights reserved.</p>
                            <p>Trụ sở: Công ty VinFast, HN – Viet Nam</p>
                        </div>
                        <div className="footer__ecosystem">
                            <a href="https://vinhomes.vn/">Vinhomes</a>
                            <a href="https://vinmec.com/">Vinmec</a>
                            <a href="https://vinpearl.com/">Vinpearl</a>
                        </div>
                    </div>
                </footer> */}

                {/* <footer className="nt-footer">
                    <div className="nt-footer__container">
                        <div className="nt-footer__top">
                            <div className="nt-footer__column">
                                <h4>Về VinFast</h4>
                                <ul>
                                    <li><a href="#">Giới thiệu VinFast</a></li>
                                    <li><a href="#">Tin tức</a></li>
                                    <li><a href="#">Ưu đãi</a></li>
                                    <li><a href="#">Truyền thông</a></li>
                                </ul>
                            </div>
                            <div className="nt-footer__column">
                                <h4>Sản phẩm</h4>
                                <ul>
                                    <li><a href="#">Ô tô điện</a></li>
                                    <li><a href="#">Xe máy điện</a></li>
                                    <li><a href="#">Hệ sinh thái</a></li>
                                    <li><a href="#">Ứng dụng VinFast</a></li>
                                </ul>
                            </div>
                            <div className="nt-footer__column">
                                <h4>Hỗ trợ khách hàng</h4>
                                <ul>
                                    <li><a href="#">Câu hỏi thường gặp</a></li>
                                    <li><a href="#">Bảo hành</a></li>
                                    <li><a href="#">Hướng dẫn sử dụng</a></li>
                                    <li><a href="#">Liên hệ</a></li>
                                </ul>
                            </div>
                            <div className="nt-footer__column">
                                <h4>Liên hệ</h4>
                                <ul>
                                    <li>Hotline: <a href="tel:1900232389">1900 23 23 89</a></li>
                                    <li>Email: <a href="mailto:[email protected]">[email protected]</a></li>
                                    <li>Trụ sở: Hải Phòng, Việt Nam</li>
                                </ul>
                                <div className="nt-footer__socials">
                                    <a href="#"><img src="/icons/fb.svg" alt="Facebook" /></a>
                                    <a href="#"><img src="/icons/youtube.svg" alt="YouTube" /></a>
                                    <a href="#"><img src="/icons/linkedin.svg" alt="LinkedIn" /></a>
                                </div>
                            </div>
                        </div>

                        <div className="nt-footer__bottom">
                            <p>© 2025 VinFast. All rights reserved.</p>
                            <div className="nt-footer__links">
                                <a href="#">Chính sách bảo mật</a>
                                <a href="#">Điều khoản sử dụng</a>
                                <a href="#">Sitemap</a>
                            </div>
                        </div>
                    </div>
                </footer> */}
            </div>
        </>
    );
};

export default TheHomepageMainLayout;
